import React from 'react';
import { Card, Col, Row, FormGroup } from 'react-bootstrap';
import { set, get, isEmpty } from 'lodash';
import { ElementTemplate } from '../TemplateComponent';
import { usePurchaseOrderState } from '../PurchaseOrderContext';
import { commonPath } from '../fieldPath';

export function RenderTermsAndCondition({ data, pIndex, isProductArchived }) {
  const { setPurchaseOrderState, purchaseOrderState, disableConditions, fromPreview, isPublicPoPage, poAddEditAccess } = usePurchaseOrderState();
  const handleChange = (value, keyName) => {
    const copyState = purchaseOrderState;
    let locate = '';
    if (keyName.includes('options')) {
      locate = keyName.split('.options');
    } else {
      locate = keyName.split('.value');
    }
    if (get(purchaseOrderState, `${locate[0]}`).hasError) {
      set(purchaseOrderState, `${locate[0]}.hasError.status`, false);
    }
    set(purchaseOrderState, keyName, value);
    setPurchaseOrderState((prevState) => ({ ...prevState, ...copyState }));
  };

  return (
    <Card className="listing-card">
      <Card.Header className="px-2 py-2 bgcolor-dark">
        <strong>{data?.label}</strong>
      </Card.Header>
      <Card.Body className="py-4">
        <Row className="span_font_size">
          {data?.columns?.map((colElement, index) => {
            const arr = colElement.filter((col) => col?.enable === true);
            return (
              !isEmpty(arr) && (
                <Col lg={6} key={index}>
                  {colElement?.map((colEle, i) => {
                    return (
                      colEle?.enable && (
                        <FormGroup key={i}>
                          <ElementTemplate
                            keys={colEle?.key}
                            name={colEle?.label}
                            placeHolder={colEle?.placeholder}
                            label={colEle?.label}
                            requiredField={colEle?.required}
                            value={colEle?.value}
                            options={colEle?.options}
                            isProductArchived={isProductArchived}
                            disable
                            onChange={handleChange}
                            path={
                              colEle?.key === 'Check_Boxes'
                                ? commonPath(pIndex, index, i).COMPANY_DETAILS_CHECKBOX
                                : commonPath(pIndex, index, i).COMPANY_DETAILS
                            }
                            error={colEle?.hasError}
                          />
                        </FormGroup>
                      )
                    );
                  })}
                </Col>
              )
            );
          })}
        </Row>
      </Card.Body>
    </Card>
  );
}

export default RenderTermsAndCondition;
